<template>
    <sa-page-layout :btnBackVisible="false" :btnNewVisible="false" :btnRefreshVisible="true" :showModalLoading="showModalLoading" @refresh="onRefresh">
        <template slot="toolbar">
            <b-button variant="success btn-toolbar float-sm-right sa-margin-right" size="sm" @click="onClickNuovo()"><b-icon icon="plus"></b-icon>Nuovo</b-button>
        </template>
        <template slot="table-filter">
            <sa-filter-component @submit="onSubmit" @reset="onReset">
                <b-row>
                    <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-search-box-label">Codice</label>
                        <div class="sa-search-search-wrapper">
                            <input class="sa-search-box-input" v-model="filtroListini.codice" placeholder="Ricerca per codice" />
                        </div>
                    </b-col>
                    <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-search-box-label">Descrizione</label>
                        <div class="sa-search-search-wrapper">
                            <input class="sa-search-box-input" v-model="filtroListini.descrizione" placeholder="Ricerca per descrizione" />
                        </div>
                    </b-col>
                </b-row>
            </sa-filter-component>
        </template>
        <template slot="table-body">
            <magazzino-listini-list-component ref="cmpMagazzinoListiniListComponent"></magazzino-listini-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import SaFilterComponent from "../../../template/layout/components/SaFilterComponent.vue";
import MagazzinoListiniListComponent from "../components/MagazzinoListiniListComponent.vue";
export default {
    components: { SaPageLayout, SaFilterComponent, MagazzinoListiniListComponent },
    data() {
        return {
            showModalLoading: false,
            linkback: "/magazzino/articoli",
            pathResource: "/magazzinoarticoli",
            jsonData: null,
            filtroListini: { codice: null, descrizione: null },
        };
    },
    mounted() {
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroListini"]) {
            this.filtroListini = JSON.parse(sessionStorage["filtroListini"]);
        }
        this.loadData();
    },
    methods: {
        loadData() {
            this.$refs.cmpMagazzinoListiniListComponent.loadDataMagazzinoListini();
        },
        onSubmit() {
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroListini"] = JSON.stringify(this.filtroListini);
            this.loadData();
        },
        onRefresh() {
            this.loadData();
        },
        onReset() {
            this.filtroListini = { codice: null, descrizione: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroListini"] = JSON.stringify(this.filtroListini);
            this.loadData();
        },
        onClickNuovo() {
            this.$refs.cmpMagazzinoListiniListComponent.nuovoMagazzinoListino();
        },
    },
};
</script>

<style></style>
